import focus_trap_vue_vue_type_script_lang_default from "./focus-trap.vue_vue_type_script_lang.mjs";
import _plugin_vue_export_helper_default from "../../../_virtual/_plugin-vue_export-helper.mjs";
import { renderSlot } from "vue";

//#region ../../packages/components/focus-trap/src/focus-trap.vue
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
	return renderSlot(_ctx.$slots, "default", { handleKeydown: _ctx.onKeydown });
}
var focus_trap_default = /* @__PURE__ */ _plugin_vue_export_helper_default(focus_trap_vue_vue_type_script_lang_default, [["render", _sfc_render]]);

//#endregion
export { focus_trap_default as default };
//# sourceMappingURL=focus-trap.mjs.map